<template>
  <svg :width="size" :height="size">
    <circle
      class="circle"
      fill="transparent"
      :stroke-width="thickness"
      :r="size / 2 - thickness / 2"
      :cx="size / 2"
      :cy="size / 2"
    />
    <circle
      class="circle"
      fill="transparent"
      :stroke-width="size / 2"
      :r="size / 4"
      :cx="size / 2"
      :cy="size / 2"
      :style="style"
    />
  </svg>
</template>

<script>
export default {
  name: "ProgressCircle",

  props: {
    thickness: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    transition: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      circumference: (this.size / 2) * Math.PI,
      percentage: 0,
      setTransition: true,
      key: 1
    };
  },

  computed: {
    style() {
      return {
        ...(this.setTransition && {
          // Autoplay + Transition Speed
          // Dont forget to match the stroke transition too
          transition: "0.5s stroke, 8s stroke-dashoffset linear"
        }),
        strokeDasharray: `${this.circumference} ${this.circumference}`,
        strokeDashoffset:
          this.circumference - (this.percentage / 100) * this.circumference
      };
    }
  },

  watch: {
    transition: {
      // immediate: true,
      handler(val) {
        if (val) {
          this.setTransition = false;
          this.percentage = 0;
        } else {
          this.setTransition = true;
          this.percentage = 100;
        }
      }
    }
  },

  async mounted() {
    // Start with an animation
    this.setTransition = false;
    this.percentage = 0;

    await this.$nextTick();

    this.setTransition = true;
    this.percentage = 100;
  }
};
</script>

<style scoped>
.circle {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  /** To match the text colour transition in utils */
  transition: 0.5s stroke;
}

.text-white .circle {
  stroke: white;
}

.text-black .circle {
  stroke: black;
}
</style>
